// src/components/Navbar.js
import React from 'react';
import { AppBar, Toolbar, IconButton, Typography, Box } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase/config';

export default function Navbar({ title, onMenuClick }) {
    const navigate = useNavigate();
    const { user } = useAuth();

    const handleLogout = async () => {
        try {
            await auth.signOut();
            navigate('/login');
        } catch (error) {
            console.error('Error logging out:', error);
        }
    };

    return (
        <AppBar
            position="sticky"
            sx={{
                bgcolor: '#fff',
                color: '#333',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                zIndex: 1100,
            }}
        >
            <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
                {/* Left side - Menu button + Title */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <IconButton
                        color="inherit"
                        onClick={onMenuClick}
                        sx={{
                            display: { xs: 'flex', md: 'none' }, // Show on mobile only
                            color: '#333',
                        }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                        {title}
                    </Typography>
                </Box>

                {/* Right side - User info + Logout */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Typography
                        variant="body2"
                        sx={{
                            color: '#666',
                            display: { xs: 'none', sm: 'block' }, // 👈 hide on mobile
                        }}
                    >
                        {user?.email}
                    </Typography>
                    <IconButton
                        onClick={handleLogout}
                        sx={{ color: '#d32f2f' }}
                        title="Logout"
                    >
                        <LogoutIcon />
                    </IconButton>
                </Box>
            </Toolbar>
        </AppBar>
    );
}
